import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { useLang, PHONE_DISPLAY, PHONE_TEL } from "@/lib/i18n";

// Google Maps embed pointing at Mosećka ul. 34, 21000 Split (Juke Transfers HQ)
const GMAPS_EMBED =
  "https://www.google.com/maps?q=Mose%C4%87ka%20ul.%2034%2C%2021000%20Split&z=14&output=embed";
const GMAPS_LINK = "https://maps.app.goo.gl/NeoFa568i4XPrXo17?g_st=ac";

export default function Contact() {
  const { t } = useLang();
  return (
    <section id="contact" data-testid="contact-section" className="relative py-28 lg:py-32 px-6 lg:px-10 bg-[#080808]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-6">
            <p className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-4">{t("contact.eyebrow")}</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white font-light tracking-tight mb-8">
              {t("contact.title")}
            </h2>
            <p className="text-zinc-400 max-w-md leading-relaxed mb-10">{t("contact.sub")}</p>

            <div className="space-y-6">
              <a href={`tel:${PHONE_TEL}`} data-testid="contact-phone" className="flex items-start gap-4 group">
                <div className="w-11 h-11 rounded-full border border-white/10 flex items-center justify-center group-hover:border-[#C5A059] transition-colors">
                  <Phone className="w-4 h-4 text-[#C5A059]" />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-zinc-500">{t("contact.phone_label")}</p>
                  <p className="text-white font-medium mt-1 group-hover:text-[#C5A059] transition-colors">{PHONE_DISPLAY}</p>
                </div>
              </a>

              <a href="mailto:bookings@juketransfers.hr" data-testid="contact-email" className="flex items-start gap-4 group">
                <div className="w-11 h-11 rounded-full border border-white/10 flex items-center justify-center group-hover:border-[#C5A059] transition-colors">
                  <Mail className="w-4 h-4 text-[#C5A059]" />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-zinc-500">{t("contact.email_label")}</p>
                  <p className="text-white font-medium mt-1 group-hover:text-[#C5A059] transition-colors">bookings@juketransfers.hr</p>
                </div>
              </a>

              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full border border-white/10 flex items-center justify-center">
                  <MapPin className="w-4 h-4 text-[#C5A059]" />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-zinc-500">{t("contact.based_label")}</p>
                  <p className="text-white font-medium mt-1">{t("contact.based_value")}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full border border-white/10 flex items-center justify-center">
                  <Clock className="w-4 h-4 text-[#C5A059]" />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-zinc-500">{t("contact.dispatch_label")}</p>
                  <p className="text-white font-medium mt-1">{t("contact.dispatch_value")}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 relative rounded-xl overflow-hidden border border-white/10 aspect-square lg:aspect-auto lg:h-[520px]">
            <iframe
              data-testid="contact-map"
              title="Juke Transfers HQ — Split, Croatia"
              src={GMAPS_EMBED}
              className="absolute inset-0 w-full h-full"
              style={{ filter: "invert(0.92) hue-rotate(180deg) brightness(0.85) contrast(0.95)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
            <a
              href={GMAPS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-map-link"
              className="absolute top-4 right-4 inline-flex items-center gap-1 rounded-full bg-black/70 backdrop-blur px-4 py-2 text-[10px] uppercase tracking-[0.2em] text-[#C5A059] hover:text-[#D4AF37] border border-white/10 hover:border-[#C5A059]/40 transition-colors"
            >
              Open in Google Maps ↗
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
